/* tslint:disable */

declare var Object: any;
export interface PlayerCommandLogInterface {
  "id": string;
  "playerId": string;
  "cmdName": string;
  "cmdValue"?: any;
  "description"?: string;
  "result"?: any;
  "complete": boolean;
  "delayed": boolean;
  "pendingDelivery": boolean;
  "hasError"?: boolean;
  "errorMessage"?: string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
}

export class PlayerCommandLog implements PlayerCommandLogInterface {
  "id": string;
  "playerId": string;
  "cmdName": string;
  "cmdValue": any;
  "description": string;
  "result": any;
  "complete": boolean;
  "delayed": boolean;
  "pendingDelivery": boolean;
  "hasError": boolean;
  "errorMessage": string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: PlayerCommandLogInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PlayerCommandLog`.
   */
  public static getModelName() {
    return "PlayerCommandLog";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PlayerCommandLog for dynamic purposes.
  **/
  public static factory(data: PlayerCommandLogInterface): PlayerCommandLog{
    return new PlayerCommandLog(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PlayerCommandLog',
      plural: 'PlayerCommandLogs',
      path: 'PlayerCommandLogs',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "playerId": {
          name: 'playerId',
          type: 'string'
        },
        "cmdName": {
          name: 'cmdName',
          type: 'string'
        },
        "cmdValue": {
          name: 'cmdValue',
          type: 'any'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "result": {
          name: 'result',
          type: 'any'
        },
        "complete": {
          name: 'complete',
          type: 'boolean'
        },
        "delayed": {
          name: 'delayed',
          type: 'boolean'
        },
        "pendingDelivery": {
          name: 'pendingDelivery',
          type: 'boolean'
        },
        "hasError": {
          name: 'hasError',
          type: 'boolean'
        },
        "errorMessage": {
          name: 'errorMessage',
          type: 'string'
        },
        "createdByIp": {
          name: 'createdByIp',
          type: 'string'
        },
        "lastUpdatedByIp": {
          name: 'lastUpdatedByIp',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/PlayerCommandLog.ts